<template>
  <div class="mobile-image-upload">
    <div class="upload-trigger" v-loading="loading" @click.stop="handleTriggerClick">
      <div class="upload-preview-box">
        <slot>
          <img v-if="value" :src="value" class="avatar">
          <div v-else class="avatar-uploader-btn">
            <i class="el-icon-plus avatar-uploader-icon"></i>
          </div>
        </slot>
      </div>
    </div>

    <!-- 隐藏的 file input（相册） -->
    <input
      ref="fileInputAlbum"
      type="file"
      accept="image/*"
      style="display:none"
      @change="onFileChange"
    >
    <!-- 隐藏的 file input（相机） -->
    <input
      ref="fileInputCamera"
      type="file"
      accept="image/*"
      capture="environment"
      style="display:none"
      @change="onFileChange"
    >

    <!-- 移动端操作选择弹窗 -->
    <div v-if="showActionSheet" class="action-sheet-mask" @click.stop="closeActionSheet">
      <div class="action-sheet" @click.stop>
        <div class="action-sheet-title">{{ $t('select_operation') || '选择操作' }}</div>
        <div class="action-sheet-btn" @click.stop="chooseFromAlbum">
          <i class="el-icon-picture-outline"></i>
          <span>{{ $t('photo_album') || '相册' }}</span>
        </div>
        <div class="action-sheet-btn" @click.stop="chooseFromCamera">
          <i class="el-icon-camera"></i>
          <span>{{ $t('camera') || '相机' }}</span>
        </div>
        <div class="action-sheet-cancel" @click.stop="closeActionSheet">
          {{ $t('cancel') || '取消' }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getIsMobile } from '@/utils/uni-bridge';
import { limitImageSizeFormat } from '@/utils/common';

export default {
  name: 'MobileImageUpload',
  props: {
    value: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    maxSize: {
      type: Number,
      default: 10
    },
  },
  data() {
    return {
      loading: false,
      showActionSheet: false,
      isMobile: false,
    };
  },
  created() {
    this.isMobile = getIsMobile();
  },
  methods: {
    handleTriggerClick() {
      if (this.disabled || this.loading) return;

      if (this.isMobile) {
        this.showActionSheet = true;
      } else {
        this.$refs.fileInputAlbum.click();
      }
    },

    closeActionSheet() {
      this.showActionSheet = false;
    },

    chooseFromAlbum() {
      this.showActionSheet = false;
      this.$nextTick(() => {
        this.$refs.fileInputAlbum.click();
      });
    },

    chooseFromCamera() {
      this.showActionSheet = false;
      this.$nextTick(() => {
        this.$refs.fileInputCamera.click();
      });
    },

    onFileChange(e) {
      const file = e.target.files && e.target.files[0];
      if (!file) return;

      e.target.value = '';

      if (!this.validateFile(file)) return;

      this.processFile(file);
    },

    validateFile(file) {
      return limitImageSizeFormat(file, this);
    },

    processFile(file) {
      this.loading = true;
      this.$getBase64(file).then(res => {
        let compressedFile = this.$base64toFile(res);
        this.$uploadFile(compressedFile).then((res) => {
          this.loading = false;
          const url = res.data.data.content[0].url;
          this.$emit('input', url);
          this.$emit('success', url);
        }).catch(() => {
          this.loading = false;
          this.$emit('error');
        });
      }).catch(() => {
        this.loading = false;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.mobile-image-upload {
  display: inline-block;
}

.upload-trigger {
  cursor: pointer;
}

.upload-preview-box {
  width: 200px;
  height: 200px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;

  /deep/ img,
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
}

.avatar-uploader-btn {
  width: 200px;
  height: 200px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 2px dashed #D8D6DE;
}

.action-sheet-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}

.action-sheet {
  width: 100%;
  max-width: 500px;
  background: #fff;
  border-radius: 12px 12px 0 0;
  overflow: hidden;
  animation: slideUp 0.3s ease;
}

@keyframes slideUp {
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
}

.action-sheet-title {
  text-align: center;
  padding: 16px;
  font-size: 14px;
  color: #999;
  border-bottom: 1px solid #f0f0f0;
}

.action-sheet-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 16px;
  font-size: 16px;
  color: #333;
  cursor: pointer;
  border-bottom: 1px solid #f0f0f0;

  &:active {
    background: #f5f5f5;
  }

  i {
    font-size: 20px;
  }
}

.action-sheet-cancel {
  text-align: center;
  padding: 16px;
  font-size: 16px;
  color: #666;
  cursor: pointer;
  margin-top: 8px;
  background: #f8f8f8;

  &:active {
    background: #eee;
  }
}
</style>
